import { nodeLink } from './../../services/fieldDataAdmin/models/models';
import { map } from 'rxjs/operators';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { IDropdownSettings } from 'ng-multiselect-dropdown/multiselect.model';
import { runInThisContext } from 'vm';
import { fieldDataAdminService } from 'src/app/services/fieldDataAdmin/field-data-admin-service.service';
import { ToastrService } from 'ngx-toastr';
import { dataField } from 'src/app/services/fieldData/querys/querys';

@Component({
    selector: 'app-edit-node',
    templateUrl: './edit-node.component.html',
    styleUrls: ['./edit-node.component.scss']
})
export class EditNodeComponent implements OnInit {

    constructor(public activeModal: NgbActiveModal, private formBuilder: FormBuilder, private dataService: fieldDataAdminService, private toastrservice: ToastrService) { }

    @Input() public row;
    @Output() passEntry: EventEmitter<any> = new EventEmitter();
    form: FormGroup;
    @Input() isAddMode: boolean;
    @Input() isAddRoot: boolean;
    submitted = false;
    loading = false;
    extraVar: any[] = [];
    extraVarSelected: any[] = [];
    dropdownSettings: IDropdownSettings;
    labelsObj: any[] = [];
    labelsDeleted: any[] = [];
    initialLabels: any[] = [];

    //bools to show properties
    showId: boolean = false;
    showTopic: boolean = false;
    showGetawayTopic: boolean = false;
    showAddress: boolean = false;
    showIp: boolean = false;
    showBaudRate: boolean = false;
    showDataBits: boolean = false;
    showEncoding: boolean = false;
    showParity: boolean = false;
    showPath: boolean = false;
    showStopBits: boolean = false;
    showType: boolean = false;
    showChannel: boolean = false;
    showModelo: boolean = false;
    showPort: boolean = false;
    showTimeout: boolean = false;
    showWait: boolean = false;
    showHost: boolean = false;

    ngOnInit() {
        //multiselect options
        this.extraVar = [{ id: 1, name: "MbDevice" },
        { id: 2, name: "MbRtu" },
        { id: 3, name: "Host" },
        { id: 4, name: "MbTelnet" },
        { id: 5, name: "Source" },
        { id: 7, name: "Gateway" },
        { id: 8, name: "MbTcp" },
        { id: 9, name: "LMping" },
        { id: 10, name: "Switch" },
        { id: 11, name: "MbBus"}];

        this.dropdownSettings = {
            singleSelection: false,
            idField: 'id',
            textField: 'name',
            itemsShowLimit: 5,
            enableCheckAll: false,
            allowSearchFilter: true
        };

        this.form = this.formBuilder.group({
            nombre: ['', Validators.required],
            uuid: [''],
            id: [''],
            topic: [''],
            gatewayTopic: [''],
            address: [''],
            ip: [''],
            baudRate: [''],
            dataBits: [''],
            encoding: [''],
            parity: [''],
            path: [''],
            stopBits: [''],
            type: [''],
            labels: [''],
            channel: [''],
            modelo: [''],
            port: [''],
            timeout: [''],
            wait: [''],
            host: ['']
        });

        if(!this.isAddRoot){
            this.orderLabels();
        }

        if (!this.isAddMode) {
            this.form.patchValue(this.row);
            this.form.controls['labels'].setValue(this.labelsObj);
            this.initialLabels = this.labelsObj;
            this.recalculateVars();
        } else {
            this.form.controls['labels'].setValue({ id: 6, name: "NodeLink" });
        }
    }

    onSubmit() {
        this.submitted = true;

        if (this.form.invalid) {
            return;
        }

        this.loading = true;
        this.labelsObj = this.form.controls['labels'].value;

        if (this.isAddMode) {
            if(this.isAddRoot){
                this.createRootNode();
            } else {
                this.createNode();
            }
        } else {
            this.updateNode();
        }
    }

    updateNode() {
        let parentId = this.row.parentId;
        let nodeLinkChilds = this.row.nodeLinkChilds;

        this.row = this.form.value;
        this.row.parentId = parentId;
        this.row.nodeLinkChilds = nodeLinkChilds;
        this.mapLabels();

        this.deleteLabels();

        this.dataService.updateNodeLinkElement(this.row).subscribe(({ data, loading}) => {
            if(data){
                this.toastrservice.success('Elemento editado correctamente');
            } else {
                this.toastrservice.error('No se ha podido editar el elemento');
            }
            this.getRowBack();
        });

        this.row.labels.map(l => {
            switch (l) {
                case "MbDevice":
                    this.dataService.updateMbDevice(this.row);
                    break;
                case "MbRtu":
                    this.dataService.updateMbRtuDevice(this.row);
                    break;
                case "Host":
                    this.dataService.updateHost(this.row);
                    break;
                case "MbTelnet":
                    this.dataService.updateMbTelent(this.row);
                    break;
                case "Source":
                    this.dataService.updateSource(this.row);
                    break;
                case "Gateway":
                    //this.dataService.updateGatewaye(this.row);
                    break;
                case "MbTcp":
                    this.dataService.updateMbTcp(this.row);
                    break;
                case "MbBus":
                    this.dataService.updateMbBus(this.row);
                    break;
                case "Switch":
                    this.dataService.updateSwitch(this.row);
                    break;
                default:
                    break;
            }
        });
    }

    deleteLabels(){
        this.labelsDeleted.map(l => {
            switch (l.name) {
                case "MbDevice":
                    this.dataService.updateMbDeviceNull(this.row.uuid);
                    break;
                case "MbRtu":
                    this.dataService.updateMbRtuDeviceNull(this.row.uuid);
                    break;
                case "Host":
                    this.dataService.updateHostNull(this.row.uuid);
                    break;
                case "MbTelnet":
                    this.dataService.updateMbTelentNull(this.row.uuid);
                    break;
                case "Source":
                    this.dataService.updateSourceNull(this.row.uuid);
                    break;
                case "Gateway":
                    //this.dataService.updateGatewaye(this.row);
                    break;
                case "MbTcp":
                    this.dataService.updateMbTcpNull(this.row.uuid);
                    break;
                case "MbBus":
                    this.dataService.updateMbBusNull(this.row.uuid);
                    break;
                case "Switch":
                    this.dataService.updateSwitchNull(this.row.uuid);
                    break;
                default:
                    break;
            }
        });
    }

    createNode() {
        let parentId = this.row.uuid; //get parentId

        this.row = this.form.value;
        this.row.parentId = parentId;
        this.row.nodeLinkChilds = 0;

        this.mapLabels();

        this.dataService.createChildNodeLink(this.row, parentId).subscribe(({ data, loading }) => {
            if(data){
                this.toastrservice.success('Elemento creado correctamente');
            } else {
                this.toastrservice.error('No se ha podido crear el elemento');
            }
            this.row.uuid = data.createChildNodeLink.uuid;
            this.getRowBack();
        }); //this will create only nodeLink and labels, then you should edit node to set properties
    }

    createRootNode() {
        this.row = this.form.value;
        this.row.nodeLinkChilds = 0;

        this.mapLabels();

        this.dataService.createRootNodeLink(this.row).subscribe(({ data, loading }) => {
            if(data){
                this.toastrservice.success('Elemento creado correctamente');
            } else {
                this.toastrservice.error('No se ha podido crear el elemento');
            }
            this.row.uuid = data.createRootNodeLink.uuid;
            this.getRowBack();
        });
    }

    mapLabels() {
        let labels: any[] = ["NodeLink"];

        if(this.row.labels.length > 0){
            this.row.labels.map(l => {
                labels.push(l.name);
            });
        }

        this.row.labels = labels;
    }

    getRowBack() {
        this.passEntry.emit(this.row);
    }

    orderLabels() {
        this.row.labels.map(l => {
            switch (l) {
                case "MbDevice":
                    this.labelsObj.push({
                        id: 1,
                        name: l,
                    });
                    break;
                case "MbRtu":
                    this.labelsObj.push({
                        id: 2,
                        name: l,
                    });
                    break;
                case "Host":
                    this.labelsObj.push({
                        id: 3,
                        name: l,
                    });
                    break;
                case "MbTelnet":
                    this.labelsObj.push({
                        id: 4,
                        name: l,
                    });
                    break;
                case "Source":
                    this.labelsObj.push({
                        id: 5,
                        name: l,
                    });
                    break;
                case "Gateway":
                    this.labelsObj.push({
                        id: 7,
                        name: l,
                    });
                    break;
                case "MbTcp":
                    this.labelsObj.push({
                        id: 8,
                        name: l,
                    });
                    break;
                case "LMping":
                    this.labelsObj.push({
                        id: 9,
                        name: l,
                    });
                    break;
                case "Switch":
                    this.labelsObj.push({
                        id: 10,
                        name: l,
                    });
                    break;
                case "MbBus":
                    this.labelsObj.push({
                        id: 11,
                        name: l,
                    });
                    break;
                default:
            }
        });
    }

    recalculateVars() {
        let labelsOnSelect =  this.form.controls['labels'].value;

        this.showId = false;
        this.showTopic = false;
        this.showGetawayTopic = false;
        this.showAddress = false;
        this.showIp = false;
        this.showBaudRate = false;
        this.showDataBits = false;
        this.showEncoding = false;
        this.showParity = false;
        this.showPath = false;
        this.showStopBits = false;
        this.showType = false;
        this.showChannel = false;
        this.showModelo = false;
        this.showPort = false;
        this.showTimeout = false;
        this.showWait = false;
        this.showHost = false;

        labelsOnSelect.map(l => {
            switch (l.name) {
                case "MbDevice":
                    this.showAddress = true;
                    break;
                case "MbRtu":
                    this.showPath = true;
                    break;
                case "Host":
                    this.showIp = true;
                    break;
                case "MbTelnet":
                    this.showIp = true;
                    this.showPort = true;
                    break;
                case "Source":
                    // this.showTopic = true;
                    // this.showModelo = true;
                    break;
                case "Gateway":

                    break;
                case "MbTcp":
                    this.showHost = true;
                    this.showPort = true;
                    break;
                case "LMping":
                    break;
                case "Switch":
                    break;
                case "MbBus":
                    this.showBaudRate = true;
                    this.showParity = true;
                    this.showDataBits = true;
                    this.showStopBits = true;
                    this.showTimeout = true;
                    this.showWait = true;
                    break;
                default:
            }
        });
    }

    onItemSelect(item: any) {
        this.recalculateVars();
    }
    onSelectAll(items: any) {
        this.recalculateVars();
    }

    onDeSelect(item: any) {
        this.labelsDeleted.push(this.initialLabels.find(x => x.name === item.name));

        this.recalculateVars();
    }

    get f() { return this.form.controls; }

}
